import { render } from "./Structure.vue?vue&type=template&id=3e37f0bc&scoped=true"
import script from "./Structure.vue?vue&type=script&setup=true&lang=js"
export * from "./Structure.vue?vue&type=script&setup=true&lang=js"

import "./StyleStructure.scss?vue&type=style&index=0&id=3e37f0bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e37f0bc"],['__file',"src/pages/scada/structure/Structure.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e37f0bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e37f0bc', __exports__)) {
    console.log('reload')
    api.reload('3e37f0bc', __exports__)
  }
  
  module.hot.accept("./Structure.vue?vue&type=template&id=3e37f0bc&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e37f0bc', render)
  })

}


export default __exports__